import React, { useEffect } from "react"

import {analyzerDate, includeProviders, mainSite, mainSiteProvider, offices, reports, repricingPass, searchID, userData} from "@signals"
import AnalyzerCommonFilters from "Pages/AnalyzersV2/Filters"
import { useAnalyzerDorFilters } from "Pages/AnalyzersV2/Dor/@hooks"
import { dorSchema } from "./schema"


export default function DorFilters() {
	const { onSubmit, isValid, errors } = useAnalyzerDorFilters()

	useEffect(() => {
		mainSiteProvider.value = false
		includeProviders.value = userData.value?.WebProviderAnalyzerGroupDefault
		mainSite.value = ''
	}, [reports.value, offices.value, repricingPass.value])

	// a report execution or a repricing pass (CU-869fmm944): the same filters follow either
	const hasExecution = !!reports.value || !!repricingPass.value

	return <AnalyzerCommonFilters
		components={{
			singleDate: false,
			lengthRental: searchID.value || !!offices.value && hasExecution,
			mainSite: searchID.value || !mainSiteProvider.value && !!offices.value && hasExecution,
			mainProvider: searchID.value || !!mainSiteProvider.value && !!offices.value && hasExecution
		}}
		compProps={{
			lengthRental: { grid: { xs: 1 }, autoSelect: true },
			dates: {
				grid: { xs: 3 }, multiple: true, autoSelect: false, disableClearable: false,
				// with a pass every date it searched arrives selected, one column each (UX Obs. 5, criterion 5)
				...repricingPass.value && { onFinishAjax: options => { if (!analyzerDate.value?.length) analyzerDate.value = options.map(o => o.value) } },
			},
		}}
		errors={errors}
		onSubmit={onSubmit}
		isValid={isValid}
		schema={dorSchema}
	/>
}